module.exports = __webpack_public_path__ + "img/loop.e503027a.svg";